import React from 'react';
import {Div} from 'd-relax-components';
import {Loader, LoaderContainer, LoaderImage, RootLoader} from './styled';
import Logo from '../../assets/kicbac_logo.svg';


const LoaderP = (props) => (
    <Div min-h-screen flex items-center justify-center {...props}>
        <RootLoader>
            <LoaderContainer>
                <Loader/>
                <LoaderImage>
                    <img src={Logo} alt=""/>
                    <div>
                        <span style={{color: '#172445', fontSize: 14}}>Loading...</span>
                    </div>
                </LoaderImage>
            </LoaderContainer>
        </RootLoader>
    </Div>
);


export default LoaderP;
